import { memo, useEffect } from 'preact/compat';
import { useAppDispatch, useAppSelector } from '../hooks';
import { clearError } from '../store/offersSlice';

const ErrorToast = memo(() => {
    const dispatch = useAppDispatch();
    const error = useAppSelector(s => s.offers.error);

    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => dispatch(clearError()), 10000);
            return () => clearTimeout(timer);
        }
    }, [error, dispatch]);

    if (!error) return null;

    return (
        <div className="toast toast-top toast-end z-50">
            <div className="alert alert-error shadow-lg max-w-xl">
                <span className="text-sm break-words whitespace-pre-wrap">{error}</span>
                <button
                    className="btn btn-ghost btn-xs"
                    onClick={() => dispatch(clearError())}
                >
                    ✕
                </button>
            </div>
        </div>
    );
});

export default ErrorToast;
